module.exports = __webpack_public_path__ + "static/vlog_cover_se-c0f45a7a604130b69685a42b3dc64c54.png";